import ImageHelper from './helper/image';

import API from '@app/api';
import Notification from '@app/store/action/notification';
import Pending from '@app/store/action/pending';

import ActionHelper from '@module/redux-actions';
import { HttpResponseCodes } from '@module/http/axios/response';

export const actions = ActionHelper.types([
  'GET_SUBSCRIPTION_PRICING',
  'GET_SEATS_PRICING',
  'RESET_SUBSCRIPTION_PRICING',
  'RESET_SEATS_PRICING',

  'SET_CREDIT_CARD_BRAND',
  'SET_ACTIVE_PAYMENT_METHOD',
  'SET_PAYMENT_METHOD_TO_COMPLETE',
  'RESET_PAYMENT_METHOD_TO_COMPLETE',

  'SET_UPLOADER_OPTIONS',
]);

const validationError = (type, mimeType) => {
  return mimeType.startsWith('video')
    ? `${type}_upload_validation_error_videos`
    : `${type}_upload_validation_error`;
};

const generateErrorMessage = (status, type, mimeType) => {
  switch (status) {
    case HttpResponseCodes.CONFLICT:
    case HttpResponseCodes.BAD_REQUEST:
    case HttpResponseCodes.NOT_FOUND:
      return validationError(type, mimeType);
    default:
      return 'something_went_wrong';
  }
};

export default ActionHelper.generate({
  getSubscriptionPricing(params = {}) {
    const pendingId = 'getSubscriptionPricing';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.UI.getSubscriptionPricing(params);
        const body = {
          type: actions.GET_SUBSCRIPTION_PRICING,
          subscriptionPricing: response.body,
        };
        dispatch(body);
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'retrieve_checkout_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  uploadCuratedWallpaper(wallpaper) {
    const pendingId = 'uploadAsset_wallpaper';

    return async (dispatch, getState) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const { account } = getState();
        const response = await ImageHelper.allocateAsset(
          account.id,
          'wallpaper',
          wallpaper.imagePath,
          true
        );

        dispatch(Pending.resetPending(pendingId));
        return response.body;
      } catch (error) {
        if (!error.aborted) {
          dispatch(
            Notification.setNotification(
              'error',
              generateErrorMessage(error.status, 'wallpaper')
            )
          );
        }
        dispatch(Pending.resetPending(pendingId));
      }
    };
  },

  uploadAsset(file, type) {
    const pendingId = 'uploadAsset_' + type;

    return async (dispatch, getState) => {
      const { size, name, type: mimeType } = file;
      if (!ImageHelper.isFileValid(type, size, mimeType)) {
        dispatch(
          Notification.setNotification('error', validationError(type, mimeType))
        );
        return;
      }

      dispatch(Pending.setPending(pendingId));

      try {
        const { account } = getState();
        const allocatedImage = await ImageHelper.allocateAsset(
          account.id,
          type,
          name
        );
        await ImageHelper.uploadAsset(
          allocatedImage.body.presigned_put_url,
          allocatedImage.body.content_type,
          file
        );

        dispatch(Pending.resetPending(pendingId));
        return allocatedImage.body.model;
      } catch (error) {
        if (!error.aborted) {
          dispatch(
            Notification.setNotification(
              'error',
              generateErrorMessage(error.status, type, mimeType)
            )
          );
        }
        dispatch(Pending.resetPending(pendingId));
      }
    };
  },

  cancelUploadAsset(type) {
    const pendingId = 'uploadAsset_' + type;

    ImageHelper.cancelUpload();

    return async (dispatch) => {
      dispatch(Pending.resetPending(pendingId));
    };
  },

  resetSubscriptionPricing: [actions.RESET_SUBSCRIPTION_PRICING],

  setActivePaymentMethod: [actions.SET_ACTIVE_PAYMENT_METHOD, 'method'],
  setCreditCardBrand: [actions.SET_CREDIT_CARD_BRAND, 'brand'],
  setPaymentMethodToComplete: [
    actions.SET_PAYMENT_METHOD_TO_COMPLETE,
    'method',
  ],
  resetPaymentMethodToComplete: [
    actions.RESET_PAYMENT_METHOD_TO_COMPLETE,
    'method',
  ],
  setUploaderOptions: [actions.SET_UPLOADER_OPTIONS, 'options'],
});
